/** Built-in pictogram assets for the gift-registry section (`/rebusy/*.svg` on Hosting). */
export const REGISTRY_REBUS_IDS = [
    "rebus_1_flowers-to-treats",
    "rebus_2_flowers-to-lottery",
    "rebus_3_flowers-to-wine",
    "rebus_4_flowers-to-book",
    "rebus_5_flowers-to-chocolate",
    "rebus_6_gift-to-letter",
    "rebus_7_gift-to-letter-to-house",
    "rebus_8_gift-to-letter-to-plane",
];
export const REGISTRY_REBUSY = [
    {
        id: "rebus_1_flowers-to-treats",
        file: "rebus_1_flowers-to-treats.svg",
        labelPl: "Zamiast kwiatów — słodycze",
    },
    {
        id: "rebus_2_flowers-to-lottery",
        file: "rebus_2_flowers-to-lottery.svg",
        labelPl: "Zamiast kwiatów — loteria",
    },
    {
        id: "rebus_3_flowers-to-wine",
        file: "rebus_3_flowers-to-wine.svg",
        labelPl: "Zamiast kwiatów — wino",
    },
    {
        id: "rebus_4_flowers-to-book",
        file: "rebus_4_flowers-to-book.svg",
        labelPl: "Zamiast kwiatów — książka",
    },
    {
        id: "rebus_5_flowers-to-chocolate",
        file: "rebus_5_flowers-to-chocolate.svg",
        labelPl: "Zamiast kwiatów — czekolada",
    },
    {
        id: "rebus_6_gift-to-letter",
        file: "rebus_6_gift-to-letter.svg",
        labelPl: "Zamiast prezentu — koperta",
    },
    {
        id: "rebus_7_gift-to-letter-to-house",
        file: "rebus_7_gift-to-letter-to-house.svg",
        labelPl: "Koperta na dom / mieszkanie",
    },
    {
        id: "rebus_8_gift-to-letter-to-plane",
        file: "rebus_8_gift-to-letter-to-plane.svg",
        labelPl: "Koperta na podróż poślubną",
    },
];
const REBUS_BY_ID = new Map(REGISTRY_REBUSY.map((r) => [r.id, r]));
export function isRegistryRebusId(value) {
    return REGISTRY_REBUS_IDS.includes(value);
}
/** Public URL path served from Hosting (`apps/web/public/rebusy/`). */
export function registryRebusPublicUrl(id) {
    return `/rebusy/${REBUS_BY_ID.get(id)?.file ?? `${id}.svg`}`;
}
